export const tableStyles = {
    table: {
        minWidth: '100%',
        border: '0.5px solid var(--line)',
    },
    thead: {
        backgroundColor: 'var(--surface-1)',
        borderBottom: '0.5px solid var(--line)',
    },
    th: {
        fontWeight: 600,
        fontSize: '0.79rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: 'color-mix(in srgb, var(--fg) 68%, transparent)',
        padding: '1rem 1rem',
    },
    td: {
        padding: '0.75rem 1rem',
        color: 'var(--color-text-primary)',
        backgroundColor: 'var(--surface-2)',
    },
    tr: {
        transition: 'background-color 0.15s ease',
        borderBottom: '0.5px solid var(--line)',
    },
};
